export default {
  // Date formatting
  'date.format': 'dd.MM.yyyy',
  'date.format_datetime': 'dd.MM.yyyy HH:mm',
  'date.format_datetime_long': "EEEE, d. MMMM yyyy 'um' HH:mm 'Uhr'",

  // Common
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.expired': 'Abgelaufen',
  'common.new': 'Neu',

  // Navigation
  'nav.external_job_markets': 'Stellen',

  // External Job Markets
  'external_job_markets.title': 'Stellen',
  'external_job_markets.jobs_count': 'Jobs',
  'external_job_markets.last_updated': 'Aktualisiert',
  'external_job_markets.select_datapool': 'Wählen Sie eine Jobbörse aus',
  'external_job_markets.select_datapool_hint': 'Wählen Sie eine der verfügbaren Jobbörsen aus, um die Jobs anzuzeigen',
  'external_job_markets.jobs_for_datapool': 'Jobs für {name}',
  'external_job_markets.search_jobs': 'Jobs durchsuchen',
  'external_job_markets.job_title': 'Jobtitel',
  'external_job_markets.company': 'Unternehmen',
  'external_job_markets.location': 'Standort',
  'external_job_markets.workload': 'Arbeitspensum',
  'external_job_markets.language': 'Sprache',
  'external_job_markets.expires': 'Läuft ab',
  'external_job_markets.view_job': 'Job anzeigen',
  'external_job_markets.create_order': 'Auftrag erstellen',
  'external_job_markets.no_jobs': 'Keine Jobs gefunden',
  'external_job_markets.no_jobs_search': 'Keine Jobs für Ihre Suche gefunden',
  'external_job_markets.no_jobs_hint': 'Diese Jobbörse enthält momentan keine aktiven Jobs',
  'external_job_markets.expires_soon': 'Läuft bald ab',
  'external_job_markets.expired': 'Abgelaufen',
  'external_job_markets.no_applications': 'Keine Bewerbungen',
  'external_job_markets.no_hires': 'Keine Einstellungen',
  'external_job_markets.not_enough_applications': 'Zu wenig Bewerbungen',
  'external_job_markets.filters': 'Filter',
  'external_job_markets.freshness': 'Aktualität',
  'external_job_markets.freshness.today': 'Letzte 24h',
  'external_job_markets.freshness.7days': 'Letzte 7 Tage',
  'external_job_markets.freshness.30days': 'Letzte 30 Tage',
  'external_job_markets.reset_filters': 'Filter zurücksetzen',
  'external_job_markets.loading_jobs': 'Jobs werden geladen...',
  'external_job_markets.job_count_info': '{filtered} von {total} Jobs',
  'external_job_markets.property_filters': 'Eigenschaften',
};
